const translations = {
  'team.seo.title': 'Our Management Team & Teachers Spain',
  'team.seo.description': `TEFL Iberia is a friendly and professional TEFL school in Barcelona. Find out more about our management team.`,
  'team.sec1.title': 'The TEFL Iberia Team',
  'team.sec1.description':
    'TEFL Iberia is made up of a unique, diverse team that shares a few key things in common: we all love learning, we are all passionate about Barcelona and we all love working in a positive environment where personal development is possible. Get to know the people that make TEFL in Barcelona happen.',
  'team.sec2.publication': 'Qualifications',
};

export default translations;
